import * as React from 'react';

import axios from 'axios';


//CORE COMPONENTS
import { 
    ThemeProvider, 
    styled 
} from '../../../components-core/packages/components-core/dist/theme-provider/index';

//LAYOUT
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';

//INPUTS
import { TextArea, InputAppearance } from '../../../components-core/packages/components-core/dist/text-area/index';
import { Checkbox } from '../../../components-core/packages/components-core/dist/checkbox/index';
import { Select } from '../../../components-core/packages/components-core/dist/select/index';

//STYLE COMPONENTS
import { Text, TextAppearance, WhiteSpace } from '../../../components-core/packages/components-core/dist/text';
import { TextInput, TextInputAppearance } from '../../../components-core/packages/components-core/dist/text-input';

import { Link } from '../../../components-core/packages/components-core/dist/link';

//CUSTOM COMPONENTS
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import contactus from './contact-us.jpg'


const TopContainer = styled.div`
    width: 100vw;
`;


class LeadSection extends React.Component {
 
    renderForms() {

        return (
            <Container 
                stretchContent={true} 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.dynamic0050}
                
            >
                <TextArea
                    label={'İsim'}
                    placeholder="Lütfen isminizi girin."
                
                    required={true}

                />
                <TextArea
                    label={'Soyisim'}
                    placeholder="Lütfen soyisiminizi girin."
                    required={true}
                />
                <TextArea
                    label={'Telefon'}
                    placeholder={'Lütfen telefon numaranızı girin.'}
                    required={true}
                />
                <TextArea
                    label={'E-Posta'}
                    placeholder={'Lütfen e-posta adresinizi girin.'}
                    required={true}
                />

                
            </Container>
        )
    }

    renderLeft() {
        return (
            <Container 
                stretchContent={true} 
                padding={leftContainerPadding} 
                wrap={ContainerWrap.always}
                gutter={ContainerGutter.dynamic0200}
            >
                {this.renderForms()}
                {this.renderButton()}
            </Container>
        )
    }





    renderButton() {
        return (
            <Container stretchContent={true} padding={buttonContainerPadding} >
                <Button appearance={ButtonAppearance.Secondary} stretchContent={true}>
                    Bilgi al
                </Button>
            </Container>
        )
    }

    renderImage() {
        return (
            <BreakpointWrapper min={Breakpoints.b1280}>


            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center} 
                verticalAlign={ContainerVerticalAlignment.center}
            >
                <img 
                    src={contactus} 
                    width={'60%'}
                    style={{marginLeft:'20%', }}
                    height={'60%'}
                    alt={'contact-us'}
                />
            </Container>
            </BreakpointWrapper>
        )
    }
 
    render() {
        return (
            
            <IntegratorRoot>
                <ThemeProvider>
                    <TopContainer  >
                        <Container 
                            stretchContent={true} 
                            padding={{ top: ContainerGutter.dynamic0200, bottom: ContainerGutter.dynamic0200 }}
                            wrap={ContainerWrap.always} 
                        >
                            <Layout appearance={layoutAppearance}>
                                {this.renderLeft()}
                                {this.renderImage()}
                            </Layout>
                        </Container>
                    </TopContainer>
                </ThemeProvider>
            </IntegratorRoot>
        )  
    }
}

const label = (text) => (
    <Text appearance={TextAppearance.copy0100} >{text}</Text>
)


const buttonContainerPadding = {
    left: {
        [Breakpoints.default]: null,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: null
    },
    right: {
        [Breakpoints.default]: null,
        [Breakpoints.b560]: ContainerPadding.grid004,
        [Breakpoints.b960]: ContainerPadding.grid004,
    }
}

const leftContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1280]: ContainerPadding.grid001
    }
}

const layoutAppearance = {
    [Breakpoints.default]: [
        { name: 'a', columns: 24 },
        { name: 'b', columns: 0 }
    ],
    [Breakpoints.b1280]: [
        { name: 'a', columns: 12 },
        { name: 'b', columns: 12 }
    ]
}


export default LeadSection;

